(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/render-bigstat.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/render-bigstat.js');
"use strict";


const BigStat = svs.components.sportinfo.bigstat.BigStat;
const logger = svs.core.log.getLogger('bigstat:render-bigstat');
const renderToDom = (querySelector, props) => {
  ReactDOM.render(React.createElement(BigStat, props, null), document.querySelector(querySelector));
};
const unmountBigStat = domElement => {
  ReactDOM.unmountComponentAtNode(domElement);
};
const renderBigStat = (querySelector, props) => {
  if (!querySelector) {
    logger.warn("No valid query selector: ".concat(props));
    return;
  }
  renderToDom(querySelector, props);
};
setGlobal('svs.components.sportinfo.bigstat.renderBigStat', renderBigStat);
setGlobal('svs.components.sportinfo.bigstat.unmountBigStat', unmountBigStat);

 })(window);